import { CertStatusValue } from '../types/enums.js';
import { CERT_EXPIRING_WINDOW_DAYS } from '../constants/misc.js';
const MS_PER_DAY = 86_400_000;
export function certStatus(expiry, now = new Date()) {
    if (!expiry)
        return CertStatusValue.expired;
    const d = expiry instanceof Date ? expiry : new Date(expiry);
    if (Number.isNaN(d.getTime()))
        return CertStatusValue.expired;
    const days = Math.floor((d.getTime() - now.getTime()) / MS_PER_DAY);
    if (days < 0)
        return CertStatusValue.expired;
    if (days <= CERT_EXPIRING_WINDOW_DAYS)
        return CertStatusValue.expiring;
    return CertStatusValue.valid;
}
export function workerCertSummary(certs, now = new Date()) {
    if (!certs || certs.length === 0)
        return 'ok';
    let hasExpired = false;
    let hasExpiring = false;
    for (const c of certs) {
        const s = c.status ?? certStatus(c.expiry, now);
        if (s === CertStatusValue.expired)
            hasExpired = true;
        else if (s === CertStatusValue.expiring)
            hasExpiring = true;
    }
    if (hasExpired)
        return 'alert';
    if (hasExpiring)
        return 'warn';
    return 'ok';
}
export function daysUntil(expiry, now = new Date()) {
    if (!expiry)
        return null;
    const d = expiry instanceof Date ? expiry : new Date(expiry);
    if (Number.isNaN(d.getTime()))
        return null;
    return Math.floor((d.getTime() - now.getTime()) / MS_PER_DAY);
}
export function isVisaExpiring(rtwStatus, rtwExpiry, within = 90, now = new Date()) {
    if (rtwStatus !== 'visa' || !rtwExpiry)
        return false;
    const d = daysUntil(rtwExpiry, now);
    return d !== null && d >= 0 && d < within;
}
export function isVisaExpired(rtwStatus, rtwExpiry, now = new Date()) {
    if (rtwStatus !== 'visa' || !rtwExpiry)
        return false;
    const d = daysUntil(rtwExpiry, now);
    return d !== null && d < 0;
}
//# sourceMappingURL=cert-status.js.map